import styled, { css } from 'styled-components';

import { SYNMATCH_RADII } from 'theme';

const PAGE_WIDTHS = {
  standard: '56.25rem',
  wide: '80rem',
} as const;

export type PageWidth = keyof typeof PAGE_WIDTHS;

const pageFillStyles = css`
  @media (min-width: 48.0625rem) {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    padding-bottom: 1.5rem;
  }
`;

export const PageContainer = styled.main<{
  $fill?: boolean;
  $width?: PageWidth;
}>`
  width: min(100% - 4rem, ${({ $width = 'standard' }) => PAGE_WIDTHS[$width]});
  margin: 0 auto;
  padding: ${({ $width = 'standard' }) =>
    $width === 'wide' ? '2rem 0 4rem' : '4rem 0'};

  ${({ $fill }) => $fill && pageFillStyles}
`;

export const ViewportFillShell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;

  @media (min-width: 48.0625rem) {
    height: 100dvh;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #475569;
`;

export const StateActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
`;

// Available to assistive tech but visually removed — names a status region
// whose visible content is a decorative loading skeleton.
export const VisuallyHidden = styled.span`
  border: 0;
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const CardSkeletonRow = styled.div`
  align-items: center;
  border: 0.0625rem solid ${({ theme }) => theme.palette.divider};
  border-radius: ${SYNMATCH_RADII.md};
  display: flex;
  gap: 0.75rem;
  padding: 0.75rem;
`;

export const CardSkeletonLines = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.375rem;
  min-width: 0;
`;

export const EmptyStateWrapper = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.5rem 0.75rem;
  text-align: center;
`;
